import * as clipboard from 'clipboard-polyfill';
import React from 'react';
import { AppButton } from '..';

const CopyItemLink = ({
  link,
  copyText,
  className = '',
  iconSize = 20,
  ...props
}) => {
  const [clicked, setClicked] = React.useState(false)

  let timerId;

  const copyUrl = () => {
    clipboard.writeText(link)

    setClicked(true)

    if (timerId) {
      clearTimeout(timerId)
    }

    timerId = setTimeout(() => {
      setClicked(false)
    }, 3000)
  }

  return (
    <AppButton outlineDark onClick={copyUrl} className={`tw-gap-2 tw-items-center ${className}`} {...props}>
      {
        clicked
          ? <>
            Copied
            <svg xmlns="http://www.w3.org/2000/svg" width={iconSize} height={iconSize} viewBox="0 0 32 32" fill="currentColor">
              <path d="M 28.28125 6.28125 L 11 23.5625 L 3.71875 16.28125 L 2.28125 17.71875 L 10.28125 25.71875 L 11 26.40625 L 11.71875 25.71875 L 29.71875 7.71875 Z"></path>
            </svg>
          </>
          : <>
            {copyText ? copyText : 'Copy'}
            <svg width={iconSize} height={iconSize} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.3385 10.7474V14.2474C13.3385 17.1641 12.1719 18.3307 9.25521 18.3307H5.75521C2.83854 18.3307 1.67188 17.1641 1.67188 14.2474V10.7474C1.67188 7.83073 2.83854 6.66406 5.75521 6.66406H9.25521C12.1719 6.66406 13.3385 7.83073 13.3385 10.7474Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M18.3385 5.7474V9.2474C18.3385 12.1641 17.1719 13.3307 14.2552 13.3307H13.3385V10.7474C13.3385 7.83073 12.1719 6.66406 9.25521 6.66406H6.67188V5.7474C6.67188 2.83073 7.83854 1.66406 10.7552 1.66406H14.2552C17.1719 1.66406 18.3385 2.83073 18.3385 5.7474Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </>
      }
    </AppButton>
  )
}

export default CopyItemLink
